import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { AssetLocationBreadcrumbs } from "~/components/AssetModalV2/Header/components/AssetLocationBreadcrumbs";
import { Header } from "~/components/AssetModalV2/Header/components/Header";
import { VersionsButton } from "~/components/AssetModalV2/Header/components/VersionsButton";
import { PublicBanner } from "~/components/AssetModalV2/Header/PublicAssetComponents/PublicBanner";
import { PublicShareButton } from "~/components/AssetModalV2/Header/PublicAssetComponents/PublicShareButton";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { useGoToPublicBoard } from "~/swr-hooks/boards/useGoToPublicBoard";
import { canSeeAssetVersions } from "~/utils/permissions/assetPermissions";
export const PublicAssetHeader = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const canViewAssetVersions = canSeeAssetVersions(permissions);
    const { goToPublicBoard } = useGoToPublicBoard();
    const onBoardClick = useCallback((board)=>{
        goToPublicBoard(board, "breadcrumb");
    }, [
        goToPublicBoard
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ _jsx(PublicBanner, {}),
            /*#__PURE__*/ _jsx(Header, {
                headerLeft: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-2",
                    children: [
                        canViewAssetVersions && /*#__PURE__*/ _jsx(VersionsButton, {}),
                        /*#__PURE__*/ _jsx(AssetLocationBreadcrumbs, {
                            onBoardClick: onBoardClick
                        })
                    ]
                }),
                headerRight: /*#__PURE__*/ _jsx("div", {
                    className: "flex items-center gap-2",
                    children: /*#__PURE__*/ _jsx(PublicShareButton, {})
                })
            })
        ]
    });
});
PublicAssetHeader.displayName = "PublicAssetHeader";
